import variableColors from "@/base/global/variables/figma.colors.json";
import variableTypography from "@/base/global/variables/figma.typography.json";
import variableEffects from "@/base/global/variables/figma.effects.json";

export const modalThemeToken: any = {
  //==================================== COLORS ====================================
  contentBg: variableColors["ColorFigmaNeutralWhiteWhite100"],
  footerBg: variableColors["ColorFigmaNeutralWhiteWhite100"],
  headerBg: variableColors["ColorFigmaNeutralWhiteWhite100"],
  titleColor: variableColors["ColorFigmaNeutralGrayscaleGray90"],
  colorBgTextHover: "transparent",
  colorBgTextActive: "transparent",
  colorIcon: variableColors["ColorFigmaNeutralGrayscaleGray70"],
  colorIconHover: variableColors["ColorFigmaNeutralGrayscaleGray70"],

  //==================================== SIZE ====================================
  titleFontSize: variableTypography["BodyH400FontSize"],
  titleLineHeight: variableTypography["BodyH400LineHeight"],
  borderRadiusLG: 4,
  borderRadiusSM: 4,
  marginXS: 16,
  padding: 18,
  boxShadow: variableEffects["BoxShadowElevation3"],
};
